import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { Check } from 'lucide-react';
import './WhyDanstonAI.css';

const WhyDanstonAI = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const benefits = [
    'Fully Custom AI Solutions',
    'Works 24x7 Without Downtime',
    'Reduces Operational Costs',
    'Improves Speed, Accuracy & Decision Making',
    'Seamlessly Integrates With Existing Systems',
  ];

  return (
    <section className="why-section" ref={ref} data-testid="why-section">
      <div className="container">
        <div className="why-header">
          <h2 className="section-title" data-testid="why-title">
            Why DanstonAI
          </h2>
          <p className="section-subtitle" data-testid="why-subtitle">
            AI isn't the future. It's your competitive advantage today.
          </p>
        </div>

        <div className="benefits-grid">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="benefit-item"
              data-testid={`benefit-${index}`}
            >
              <div className="benefit-icon">
                <Check size={24} />
              </div>
              <span className="benefit-text">{benefit}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyDanstonAI;
